var jade = require("/app/app/assets/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<input type=\"text\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" ng-model=\"query\" ng-model-options=\"{ debounce: 100 }\" ng-keydown=\"keydown($event)\"><a href=\"#\" ng-click=\"fire()\" ng-show=\"buttonText\" class=\"od-xhr-progress button submit white\">{{buttonText}}</a><ul ng-show=\"results[0]\"><li ng-repeat=\"result in results\" ng-class=\"{ selected: result.selected }\" ng-click=\"click(result)\">{{result.description}}</li></ul><small ng-show=\"addressErrors\" class=\"inline-error\">We couldn't find that address. Try without zip codes or unit numbers. Or try our &nbsp;<a href=\"#\" ng-click=\"$parent.goToManualEntry()\">simplified form.</a></small>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./javascripts/common/directives/place-autocomplete.jade
 ** module id = 825
 ** module chunks = 0 1 3 4 5 6
 **/